import React from "react";
import { Category } from "../types";

interface CategoryModalProps {
  isOpen: boolean;
  isEdit: boolean;
  category: Category | null;
  onSave: () => void;
  onCancel: () => void;
  onDelete: (id: number) => void;
  onCategoryChange: (category: Category) => void;
}

export const CategoryModal: React.FC<CategoryModalProps> = ({
  isOpen,
  isEdit,
  category,
  onSave,
  onCancel,
  onDelete,
  onCategoryChange,
}) => {
  if (!isOpen || !category) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        zIndex: 1000,
        animation: "fadeIn 0.1s ease-out forwards",
        overflowY: "auto",
        padding: "20px 0"
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "24px",
          borderRadius: "16px",
          width: "90%",
          maxWidth: "400px",
          margin: "auto",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        }}
      >
        <h3 style={{
          fontSize: "20px",
          fontWeight: 600,
          marginBottom: "24px",
          color: "#000"
        }}>
          {isEdit ? "Edit Category" : "Add Category"}
        </h3>

        <input
          type="text"
          placeholder="Name"
          value={category.name || ""}
          onChange={(e) => onCategoryChange({ ...category, name: e.target.value })}
          style={{
            width: "100%",
            padding: "12px 16px",
            marginBottom: "24px",
            borderRadius: "12px",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
            color: "#000",
            fontSize: "16px",
            outline: "none",
          }}
        />

        <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "24px" }}>
          <div style={{ display: "flex", gap: "12px" }}>
            <button
              onClick={() => {
                if (isEdit) {
                  onDelete(category.id);
                } else {
                  onCancel();
                }
              }}
              style={{
                flex: 1,
                padding: "14px",
                backgroundColor: "#dc3545",
                color: "#fff",
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              {isEdit ? "Delete" : "Cancel"}
            </button>
            <button
              onClick={onSave}
              disabled={!category.name}
              style={{
                flex: 1,
                padding: "14px",
                backgroundColor: "#28a745",
                color: "#fff",
                border: "none",
                borderRadius: "12px",
                cursor: !category.name ? "not-allowed" : "pointer",
                opacity: !category.name ? 0.5 : 1,
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};